export enum ChildCriteriaRegionEnum {
  Africa = 'Africa',
  Asia = 'Asia',
  CentralAmericaAndCaribbean = 'Central America and Caribbean',
  SouthAmerica = 'South America',
}

export enum ChildGenderEnum {
  Male = 'Male',
  Female = 'Female',
  Either = 'Either',
}

export interface ChildBase {
  state?: string | null;
  holdingGlobalPartnerId?: string | null;
  holdExpirationDate?: string | null;
}

export interface ChildBirthday {
  birthDate: string;
}

export interface ChildCountry {
  country?: string | null;
}

export interface ChildGender {
  gender: ChildGenderEnum;
}

export interface ChildGlobalId {
  globalId: string;
}

export interface ChildFieldOffice {
  fieldOffice?: string | null;
}

export interface ChildIcp {
  icp: {
    country?: string | null;
    id?: string | null;
    // name?: string | null; // Sensitive
  };
}

export interface ChildImageUrl {
  imageUrl: string;
}

export interface ChildLocalId {
  localId: string;
  localNumber?: string | null;
}

export interface ChildLocalNumber {
  localNumber?: string | null;
}

export interface ChildName {
  name: {
    first: string;
    preferred: string;
  };
}

export type ChildIsHivArea = {
  isInHivAffectedArea?: boolean;
};

export type ChildIsOrphan = {
  isOrphan: boolean;
};

export type ChildIsSpecialNeeds = {
  isSpecialNeeds: boolean;
};

export interface ChildEducation {
  academicPerformance: string | null;
  formalLevel: string;
  gradeLevel: {
    local: string;
    us: string;
  };
  majorOrCourseOfStudy?: string | null;
  notEnrolledInEducationReason?: string | null;
}

export interface HouseholdGuardian {
  employmentStatus: string;
  occupation?: string | null;
}

export interface HouseholdParent {
  isAlive: string;
  isLivingWithChild: boolean;
}

export interface HouseholdMemberItem {
  globalId?: string | null;
  localId?: string | null;
  householdMemberName: string;
  householdMemberRole: string;
  isCaregiver: boolean;
  isPrimaryCaregiver: boolean;
}

export interface HouseholdList {
  femaleGuardian: HouseholdGuardian;
  household: {
    id: string;
    name: string;
  };
  householdMemberList?: HouseholdMemberItem[] | null;
  maleGuardian: HouseholdGuardian;
  parents: {
    naturalFather: HouseholdParent;
    naturalMother: HouseholdParent;
    maritalStatus: string;
    together: string;
  };
  siblings: {
    numberOfBrothers: number;
    numberOfSiblingChildren: number;
    numberOfSisters: number;
  };
  youthHeadedHousehold: boolean;
  revisedValues: string;
  sourceKit: string;
}
/**
 * This interface should be used for all Child data (sub-interfaces).
 * It is an aggregate of all the Child properties returned from
 * the upstream APIs (e.g. AM) and should be considered the
 * "single source of truth" for Child data types...or...
 * the "one ring to rule them all!"
 */
// export interface ChildAggregate {
//     aidsLinkTitleText?: string | null;
//     aidsRibbon: boolean;
//     baseImageUrl: string;
//     bioLinkUrl?: string | null;
// }

export type ChildCriteria = {
  ageMax?: number | null;
  ageMin?: number | null;
  birthDay?: string | null;
  birthMonth?: string | null;
  countries?: string[] | null;
  disability?: boolean | null;
  gender?: ChildGenderEnum | null;
  isInHivAffectedArea?: boolean | null;
  isOrphan?: boolean | null;
  region?: ChildCriteriaRegionEnum | null;
  referrer?: string;
};
